import React, { useEffect, useState } from "react";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";

// ✅ توليد أرقام الأرباح الثابتة والمتزايدة أسبوعيًا
const generateWeeklyProfits = () => {
  const base = 3498;
  const dailyIncrement = 100;
  const days = ["السبت", "الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة"];

  return days.map((day, index) => ({
    day,
    profit: base + index * dailyIncrement,
  }));
};

// ✅ بطاقات المميزات
const features = [
  { icon: "bx bx-money", title: "استلام أرباح يومية", desc: "تحقق أرباحك بشكل مستمر وآمن." },
  { icon: "bx bx-coin-stack", title: "نبدأ بـ 15$ فقط", desc: "يمكنك البدء برأس مال بسيط ومضمون." },
  { icon: "bx bxl-tether", title: "USDT مباشر", desc: "السحب والإيداع يتم فورياً عبر USDT." },
  { icon: "bx bx-shield-quarter", title: "تحمل كامل للمسؤولية", desc: "نضمن عدم الخسارة وتحمل كامل للمخاطر." },
  { icon: "bx bx-bar-chart", title: "نسبة ربح 40%", desc: "نأخذ فقط نسبة بسيطة من أرباحك." },
  { icon: "bx bx-bulb", title: "ذكاء تداولي", desc: "تحليل آلي يعتمد على خوارزميات دقيقة." },
];

export default function SessionResultsPage() {
  const [profits, setProfits] = useState<{ day: string; profit: number }[]>([]);

  useEffect(() => {
    setProfits(generateWeeklyProfits());
  }, []);

  return (
    <div className="text-white w-full flex flex-col items-center px-4 md:px-12 py-10">
      <h2 className="text-3xl md:text-4xl font-black text-center text-[#22ff9b] mb-6 flex items-center gap-3">
        <i className="bx bxs-bar-chart-alt-2 text-[#22ff9b] text-4xl"></i> نتائج الجلسات الأسبوعية
      </h2>

      <p className="text-center text-lg text-gray-300 mb-10 max-w-2xl">
        يعرض هذا الشارت تطور أرباح الجلسات اليومية على مدار الأسبوع، ويُحدث تلقائيًا كل أسبوع.
      </p>

      {/* ✅ الشارت */}
      <div className="w-full max-w-4xl h-72 bg-[#0d132b]/50 border border-[#22ff9b]/20 rounded-3xl shadow-[0_0_40px_rgba(34,255,155,0.1)] backdrop-blur-md p-6 mb-12">
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={profits} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="rgba(34,255,155,0.15)" />
            <XAxis dataKey="day" stroke="#a3f9d4" tick={{ fontSize: 13 }} />
            <YAxis stroke="#a3f9d4" tick={{ fontSize: 13 }} />
            <Tooltip
              contentStyle={{
                backgroundColor: "rgba(13,19,43,0.9)",
                border: "1px solid rgba(34,255,155,0.3)",
                borderRadius: "10px",
              }}
              labelStyle={{ color: "#22ff9b" }}
            />
            <Line type="monotone" dataKey="profit" stroke="#22ff9b" strokeWidth={3} dot={{ r: 4, fill: "#22ff9b" }} />
          </LineChart>
        </ResponsiveContainer>
      </div>

      {/* ✅ بطاقات المميزات */}
      <div className="w-full max-w-6xl grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {features.map((f, i) => (
          <div
            key={i}
            className="bg-[rgba(13,19,43,0.65)] border border-[rgba(34,255,155,0.15)] p-6 rounded-2xl backdrop-blur-lg shadow-[0_0_25px_rgba(34,255,155,0.05)] flex flex-col items-center text-center hover:-translate-y-2 transition-transform"
          >
            <i className={`${f.icon} text-4xl text-[#22ff9b] mb-3`}></i>
            <h3 className="text-xl font-bold text-white mb-2">{f.title}</h3>
            <p className="text-gray-400 text-sm">{f.desc}</p>
          </div>
        ))}
      </div>

      {/* ✅ زر الانضمام */}
      <div className="text-center mt-14">
        <a
          href="https://t.me/m/92P7MxawM2Rk"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2.5 bg-gradient-to-r from-[#22ff9b] to-[#1de48b] text-[#060c1f] py-3.5 px-8 rounded-xl font-black uppercase tracking-wider shadow-[0_0_18px_#22ff9b44] hover:scale-105 transition-transform"
        >
          <i className="bx bxl-telegram text-xl"></i> انضم الآن وشاهد بنفسك
        </a>
      </div>
    </div>
  );
}
